import { createFileRoute } from "@tanstack/react-router";

import { AuthGate } from "@/components/AuthGate";
import { SharedByMeView } from "@/components/SharedByMeView";

export const Route = createFileRoute("/shared-by-me")({
  component: function SharedByMePage() {
    return (
      <AuthGate>
        <SharedByMeView />
      </AuthGate>
    );
  },
});
